import { object } from 'prop-types'
import React, { createContext, useState } from 'react'

export const ArticleContext = createContext({})

const ArticleProvider = ({ children }) => {
  const [articleCategory, setArticleCategory] = useState(null)

  return (
    <ArticleContext.Provider
      value={{
        articleCategory,
        setArticleCategory,
      }}
    >
      {children}
    </ArticleContext.Provider>
  )
}

ArticleProvider.propTypes = {
  children: object.isRequired,
}

export default ArticleProvider
